export const Dataset = {
  list: function () {
    var options = {
      bDeferRender: true,
      data: JSON.parse(jQuery("#dataset-list-data").html()),
      info: false,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      pageLength: 20,
      autoWidth: false,
      initComplete: function () {
        DataTablesHelper.setAutoComplete(jQuery("#dataset-list"));
      },
      columnDefs: [
        {
          render: function (data, type, row, meta) {
            if (type == "display") {
              return jQuery("#dataset-name-template").html().replace("__label__", data.label).replace("__href__", data.href);
            } else {
              return data.label;
            }
          },
          targets: [0],
        },
        {
          targets: [-1],
          searchable: false,
          sortable: false,
        },
      ],
      drawCallback: function () {
        ActionJS.Dataset.priv.bindEvent();
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    };

    var table = jQuery("#dataset-list");
    table.DataTable(options);
  },

  priv: {
    bindEvent: function () {
      jQuery(".dataset-clone-link, .dataset-delete-link")
        .off("click")
        .on("click", function (e) {
          e.stopPropagation();
          var c = true;
          if (jQuery(this).data("confirm")) {
            c = confirm(jQuery(this).data("confirm"));
          }
          if (c) {
            jQuery
              .ajax({
                url: jQuery(this).attr("href"),
                method: "POST",
                headers: { "X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr("content") },
              })
              .done(function (d) {
                Turbo.visit(window.location.href);
              });
          }
          e.preventDefault();
        });
    },
  },
};
